"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssignmentEventReport = exports.createGroupReport = exports.createStateInteractionReport = exports.createLiveClassReport = exports.createContentVersionLogReport = exports.createUserReport = exports.createContentReport = exports.createUserContentReport = void 0;
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
function createUserContentReport(input) {
    const { userContentMetrics = [], users = [], contents = [], total } = input;
    const usersById = keyBy_1.default(users, '_id');
    const contentsById = keyBy_1.default(contents, '_id');
    const reports = userContentMetrics.map(metric => ({
        userContentMetric: metric,
        user: usersById[metric.userId],
        content: contentsById[metric.contentId]
    }));
    return { total, reports };
}
exports.createUserContentReport = createUserContentReport;
function createContentReport(input) {
    const { contentMetrics = [], contents = [], total, contentTypeAggregation = [] } = input;
    const contentMetricsById = keyBy_1.default(contentMetrics, 'contentId');
    const reports = contents.map(content => ({
        contentMetric: contentMetricsById[content._id],
        content
    }));
    return { total, reports, aggregations: { contentTypeAggregation } };
}
exports.createContentReport = createContentReport;
function createUserReport(input) {
    const { userMetrics = [], users = [], total } = input;
    const userMetricsById = keyBy_1.default(userMetrics, 'userId');
    const reports = users.map(user => ({
        userMetric: userMetricsById[user._id],
        user
    }));
    return { total, reports };
}
exports.createUserReport = createUserReport;
function createContentVersionLogReport(input) {
    const { contentVersionLogMetrics = [], contentVersionLogs = [], total } = input;
    const contentVersionLogMetricsById = keyBy_1.default(contentVersionLogMetrics, 'enrolmentVersionId');
    const reports = contentVersionLogs.map(contentVersionLog => ({
        contentVersionLogMetric: contentVersionLogMetricsById[contentVersionLog.versionId],
        contentVersionLog
    }));
    return { total, reports };
}
exports.createContentVersionLogReport = createContentVersionLogReport;
function createLiveClassReport(input) {
    const { liveClasses = [], total } = input;
    const reports = liveClasses;
    return { total, reports };
}
exports.createLiveClassReport = createLiveClassReport;
function createStateInteractionReport(input) {
    const { stateInteractions = [], users = [], contents = [], total } = input;
    const usersById = keyBy_1.default(users, '_id');
    const contentsById = keyBy_1.default(contents, '_id');
    const reports = stateInteractions.map(metric => ({
        stateInteraction: metric,
        user: usersById[metric.userId],
        content: contentsById[metric.contentId || metric.questionId]
    }));
    return { total, reports };
}
exports.createStateInteractionReport = createStateInteractionReport;
function createGroupReport(input) {
    const { groups = [], total, userGroupMetrics, contentGroupMetrics } = input;
    const userGroupMetricsById = keyBy_1.default(userGroupMetrics, 'groupId');
    const contentGroupMetricsById = keyBy_1.default(contentGroupMetrics, 'groupId');
    const reports = groups.map(group => ({
        group,
        groupMetrics: userGroupMetricsById[group.id] || contentGroupMetricsById[group.id]
    }));
    return { total, reports };
}
exports.createGroupReport = createGroupReport;
function createAssignmentEventReport(input) {
    const { assignmentEvents = [], total, assignmentEventUserMetrics } = input;
    const assignmentEventUserMetricsById = keyBy_1.default(assignmentEventUserMetrics, 'assignnmentEventId');
    const reports = assignmentEvents.map((assignmentEvent) => ({
        assignmentEvent,
        assignmentEventMetric: assignmentEventUserMetricsById[assignmentEvent.id]
    }));
    return { total, reports };
}
exports.createAssignmentEventReport = createAssignmentEventReport;
//# sourceMappingURL=createReport.js.map